import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import './About.scss';

const About = () => {
  return (
    <section id="about" className="about-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          About Me
        </Typography>
        <Box className="section-divider" />
        <Paper elevation={3} className="about-content">
          <Typography variant="body1" className="about-text">
            I am an AI-focused full-stack software engineer with over 8 years of experience building 
            cloud-native, multi-cloud (AWS, Azure, GCP) and on-premise systems. My expertise lies in 
            integrating retrieval-augmented generation and intelligent workflows into scalable, 
            high-performance web applications across finance, healthcare, and e-commerce domains.
          </Typography>
          <Typography variant="body1" className="about-text">
            Throughout my career, I have demonstrated a strong ability to architect and develop 
            complex software solutions, from serverless APIs and single-page web applications to 
            message queues and data visualization systems. I specialize in leveraging modern 
            technologies and frameworks to deliver solutions that not only meet but exceed 
            performance expectations.
          </Typography>
          <Typography variant="body1" className="about-text">
            My passion for continuous learning drives me to stay at the forefront of technology, 
            particularly in the rapidly evolving fields of AI and machine learning. I am committed 
            to creating innovative solutions that solve real-world problems and deliver measurable 
            business value.
          </Typography>
        </Paper>
      </Container>
    </section>
  );
};

export default About;

